import { DOMElement } from "react"

declare const TEXT_ENGINE_SVC: string
export function printOrderIFrame(orderUUID: string): Promise<void> {
  return new Promise((resolve, _reject) => {
    fetch(`${TEXT_ENGINE_SVC}/render`, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        'X-Client': 'CustomerService',
      }),
      body: JSON.stringify({
        parts: [payload],
        compiled_parts: [compiled],
        template_type: 'Restaurant Order',
        order_uuid: orderUUID,
      })
    })
      .then(res => res.json())
      .then(({ parts }) => Promise.resolve(`<!DOCTYPE html>
    <html>
        <head>
            <title>Print Order</title>
        </head>
        <body>
          ${parts[0]}
        </body>
    </html>`))
      .then(winHtml => {
        printIt(winHtml, resolve)
      })
  })
}


function printIt(content: Element, onAfterPrint: () => void) {
  if (!content) {
    console.error(`Can't find element to print`)
    return null
  }

  const frame = document.createElement('iframe')
  frame.style.position = 'absolute'
  frame.style.top = '-2000px'
  frame.style.left = '-2000px'
  frame.id = 'printFrame'

  frame.onload = function() {
    const frameDocument = frame.contentDocument || frame.contentWindow.document

    frameDocument.open()
    frameDocument.write(content.outerHTML)
    frameDocument.close()

    return setTimeout(function() {
      frame.contentWindow.focus()
      frame.contentWindow.print()
      document.body.removeChild(document.getElementById('printFrame'))
      if (!!onAfterPrint && (typeof onAfterPrint === "function")) {
        return onAfterPrint()
      }
    }
      , 500)
  }

  return document.body.appendChild(frame)
}


export function printOrderExternalWindow(orderUUID: string): Promise<boolean> {
  return fetch(`${TEXT_ENGINE_SVC}/render`, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      'X-Client': 'CustomerService',
    }),
    body: JSON.stringify({
      parts: [payload],
      compiled_parts: [compiled],
      template_type: 'Restaurant Order',
      order_uuid: orderUUID,
    })
  })
    .then(res => res.json())
    .then(({ parts }) => Promise.resolve(`<!DOCTYPE html>
    <html>
        <head>
            <title>Print Order</title>
        </head>
        <body>
          ${parts[0]}
        </body>
    </html>`))
    .then(winHtml => {
      const winUrl = URL.createObjectURL(
        new Blob([winHtml], { type: "text/html" })
      );

      const newWindow = window.open(winUrl, `print-${orderUUID}`, `width=800,height=400,screenX=200,screenY=200`)
      if (newWindow) {
        newWindow.print()
        newWindow.onafterprint = () => {
          // setPrinting(false)
          newWindow.close()
        }
        return Promise.resolve(true)
      } else {
        return Promise.resolve(false)
      }
    }).catch(() => Promise.resolve(false))
}

const payload = `
<UI.Template format="print">

  <UI.Grid>
    <UI.Row>
      <UI.Cell center py={2}>
        <UI.Heading><Data.Restaurant.Name /></UI.Heading>
      </UI.Cell>
    </UI.Row>
  </UI.Grid>
  
  <UI.Container >
    <UI.Grid>
      <UI.Row>
        <UI.Cell left p={3}>
          <UI.Text>Order for <strong><Data.Order.Service.Label /></strong></UI.Text>
          <UI.Text>from <strong><Data.Channel.Name /></strong></UI.Text>
        </UI.Cell>
        <UI.Cell right p={3}>
          <UI.Text>Confirmation Code</UI.Text>
          <UI.Text fontWeight={2} fontSize={4}><Data.Order.ConfCode /></UI.Text>
        </UI.Cell>
      </UI.Row>    
    </UI.Grid>
  </UI.Container>
  
  <UI.Container>
    <UI.Grid fontSize={2}>
      <UI.Row sizes={["50%", "50%"]}>
        <UI.Cell brand p={3} borderBottom={1} borderColor='background2'>
          <UI.Text fontWeight={3}>Guest Info</UI.Text>
        </UI.Cell>
        <UI.Cell brand p={3} borderBottom={1} borderColor='background2' right>
          <UI.Text fontWeight={3}>Order Info</UI.Text>
        </UI.Cell>
      </UI.Row>
      <UI.Row>
        <UI.Cell borderRight={1} borderBottom={1} borderColor='background2' p={3}>
          <UI.Text><UI.Span mid>Name:</UI.Span> <Data.Order.Customer.Name /></UI.Text>
          <UI.Text><UI.Span mid>Email:</UI.Span> <Data.Order.Customer.Email /></UI.Text>
          <UI.Text><UI.Span mid>Phone:</UI.Span> <Data.Order.Customer.Phone /></UI.Text>
        </UI.Cell>
        <UI.Cell p={3} borderBottom={1} borderColor="background2" right>
          <UI.Text><UI.Span mid>Order ID:</UI.Span> <UI.Span fontWeight={3}>#<Data.Order.ShortId/></UI.Span></UI.Text>
          <UI.Text>
            <Data.Order.Time.Id/> @ 
            <UI.Span fontWeight={3}> <Data.Order.Time.Value format='lll'/></UI.Span>
          </UI.Text>
          <UI.Text>
            <Data.Order.Tender.Label/>
          </UI.Text>
          <UI.Text>
            <Data.Order.Tender.CardInfo/>          
          </UI.Text>
        </UI.Cell>
      </UI.Row>
      
      <UI.Row>
        <UI.Cell span={2} p={3} borderBottom={1} borderColor="background2" center>
          
          <Data.Order.Service.Delivery>
            <UI.Text>
              Delivery to <UI.Span fontWeight={3}><Data.Order.Delivery.FullAddress /></UI.Span>
            </UI.Text>
            <UI.Text>
              <UI.Span mid>Instructions: </UI.Span>
              <Data.Order.Delivery.Instructions />
            </UI.Text>
          </Data.Order.Service.Delivery>
          
          <Data.Order.Service.Pickup>
            <UI.Text>
              Pickup from <UI.Span fontWeight={3}><Data.Order.Pickup.Address /></UI.Span>
            </UI.Text>
          </Data.Order.Service.Pickup>
          
          <Data.Order.Service.Dinein>
            <UI.Text>
              Dine In at <UI.Span fontWeight={3}><Data.Order.Dinein.Address /></UI.Span>
            </UI.Text>
          </Data.Order.Service.Dinein>
          
          <Data.Order.Service.Curbside>
            <UI.Text>
              Curb Service - To vehicle:
              <UI.Span fontWeight={3}> <Data.Order.Curbside.Info /></UI.Span>
            </UI.Text>
          </Data.Order.Service.Curbside>
          
        </UI.Cell>
      </UI.Row>
      
    </UI.Grid>
  </UI.Container>
  
  <UI.Container>
    <UI.StandardExtraFields />
  </UI.Container>
  
  <UI.Container>
    <UI.StandardCartContents/> 
  </UI.Container>

</UI.Template>
`

const compiled = `
'use strict';
render(React.createElement(UI.Template, { format: 'print' }, React.createElement(UI.Grid, null, React.createElement(UI.Row, null, React.createElement(UI.Cell, {
    center: true,
    py: 2
}, React.createElement(UI.Heading, null, React.createElement(Data.Restaurant.Name, null))))), React.createElement(UI.Container, null, React.createElement(UI.Grid, null, React.createElement(UI.Row, null, React.createElement(UI.Cell, { left: true }, React.createElement(UI.Text, null, 'Order for ', React.createElement('strong', null, React.createElement(Data.Order.Service.Label, null))), React.createElement(UI.Text, null, 'from ', React.createElement('strong', null, React.createElement(Data.Channel.Name, null)))), React.createElement(UI.Cell, { right: true }, React.createElement(UI.Text, null, 'Confirmation Code'), React.createElement(UI.Text, {
    fontWeight: 2,
    fontSize: 6
}, React.createElement(Data.Order.ConfCode, null)))))), React.createElement(UI.Container, null, React.createElement(UI.Grid, { fontSize: 2 }, React.createElement(UI.Row, {
    sizes: [
        '50%',
        '50%'
    ]
}, React.createElement(UI.Cell, {
    brand: true,
    p: 2,
    borderBottom: 1,
    borderColor: 'background2'
}, React.createElement(UI.Text, { fontWeight: 3 }, 'Guest Info')), React.createElement(UI.Cell, {
    brand: true,
    p: 2,
    borderBottom: 1,
    borderColor: 'background2',
    right: true
}, React.createElement(UI.Text, { fontWeight: 3 }, 'Order Info'))), React.createElement(UI.Row, null, React.createElement(UI.Cell, {
    borderRight: 1,
    borderBottom: 1,
    borderColor: 'background2',
    p: 2
}, React.createElement(UI.Text, null, React.createElement(UI.Span, { mid: true }, 'Name:'), ' ', React.createElement(Data.Order.Customer.Name, null)), React.createElement(UI.Text, null, React.createElement(UI.Span, { mid: true }, 'Email:'), ' ', React.createElement(Data.Order.Customer.Email, null)), React.createElement(UI.Text, null, React.createElement(UI.Span, { mid: true }, 'Phone:'), ' ', React.createElement(Data.Order.Customer.Phone, null))), React.createElement(UI.Cell, {
    p: 2,
    borderBottom: 1,
    borderColor: 'background2',
    right: true
}, React.createElement(UI.Text, null, React.createElement(UI.Span, { mid: true }, 'Order ID:'), ' ', React.createElement(UI.Span, { fontWeight: 3 }, '#', React.createElement(Data.Order.ShortId, null))), React.createElement(UI.Text, null, React.createElement(Data.Order.Time.Id, null), ' @', React.createElement(UI.Span, { fontWeight: 3 }, ' ', React.createElement(Data.Order.Time.Value, { format: 'lll' }))), React.createElement(UI.Text, null, React.createElement(Data.Order.Tender.Label, null)), React.createElement(UI.Text, null, React.createElement(Data.Order.Tender.CardInfo, null)))), React.createElement(UI.Row, null, React.createElement(UI.Cell, {
    span: 2,
    p: 2,
    borderBottom: 1,
    borderColor: 'background2',
    center: true
}, React.createElement(Data.Order.Service.Delivery, null, React.createElement(UI.Text, null, 'Delivery to ', React.createElement(UI.Span, { fontWeight: 3 }, React.createElement(Data.Order.Delivery.FullAddress, null))), React.createElement(UI.Text, null, React.createElement(UI.Span, { mid: true }, 'Instructions: '), React.createElement(Data.Order.Delivery.Instructions, null))), React.createElement(Data.Order.Service.Pickup, null, React.createElement(UI.Text, null, 'Pickup from ', React.createElement(UI.Span, { fontWeight: 3 }, React.createElement(Data.Order.Pickup.Address, null)))), React.createElement(Data.Order.Service.Dinein, null, React.createElement(UI.Text, null, 'Dine In at ', React.createElement(UI.Span, { fontWeight: 3 }, React.createElement(Data.Order.Dinein.Address, null)))), React.createElement(Data.Order.Service.Curbside, null, React.createElement(UI.Text, null, 'Curb Service - To vehicle:', React.createElement(UI.Span, { fontWeight: 3 }, ' ', React.createElement(Data.Order.Curbside.Info, null)))))))), React.createElement(UI.Container, null, React.createElement(UI.StandardExtraFields, null)), React.createElement(UI.Container, null, React.createElement(UI.StandardCartContents, null))));
`
